<template>
  <div
    :class="{ 'py-14': !isRegion }"
    class="mx-auto flex flex-col justify-center items-center text-center h-full"
  >
    <img
      :src="getAssetUrl('/images/empty-results.svg')"
      :alt="$t('search.empty-results')"
      class="w-52"
    />
    <div class="max-w-72">
      <p class="mt-6 font-title text-xl text-neutral-900 font-bold">
        {{ header }}
      </p>
      <p
        v-if="subheader"
        class="mt-2 text-sm text-neutral-500"
      >
        {{ subheader }}
      </p>
      <slot name="body" />
    </div>
  </div>
</template>

<script>
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterEmptySearch',

  props: {
    header: {
      type: String,
      required: true,
    },
    isRegion: {
      type: Boolean,
      default: false,
    },
    subheader: {
      type: String,
      default: null,
    },
  },

  setup() {
    return {
      getAssetUrl,
    };
  },
};
</script>
